import { render, staticRenderFns } from "./StatisticsTemplate.vue?vue&type=template&id=5ddac0aa&"
import script from "./StatisticsTemplate.vue?vue&type=script&lang=js&"
export * from "./StatisticsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTemplate.vue?vue&type=style&index=0&id=5ddac0aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports